import { PEV } from "../../../../common/utils";

export const userGroupInfoCalledBy = "userGroupInfo";

export const ownersKey = "owners";
export const membersKey = "members";

export function getUsersForOwnersTablePendingState(state, pendingAction) {
  const { userGroupUniqueName } = pendingAction.meta.arg;
  state.userGroupUserInfoTableContent[userGroupUniqueName] = {
    ...state.userGroupUserInfoTableContent?.[userGroupUniqueName],
  };
  state.userGroupUserInfoTableContent[userGroupUniqueName][ownersKey] = PEV(
    {},
    `Fetching User Group ${ownersKey} table Content`
  );
}
export function getUsersForOwnersTableSuccessState(state, action) {
  const { userGroupUniqueName } = action.meta.arg;
  state.userGroupUserInfoTableContent[userGroupUniqueName][ownersKey] = PEV(action.payload);
}
export function getUsersForOwnersTableRejectedState(state, rejectedAction) {
  const { userGroupUniqueName } = rejectedAction.meta.arg;
  state.userGroupUserInfoTableContent[userGroupUniqueName][ownersKey] = PEV(
    {},
    null,
    `Error while fetching User Group ${ownersKey} table`
  );
}
